import React, { useState, useEffect, useRef } from 'react';

const CapsuleShop = () => {
  const [playerInfo, setPlayerInfo] = useState(null);
  const [showSetup, setShowSetup] = useState(true);
  const [selectedCapsule, setSelectedCapsule] = useState(null);
  const [unopenedCapsules, setUnopenedCapsules] = useState([]);
  const [euros, setEuros] = useState(26775);
  const [ap, setAp] = useState(1200);
  const [bp, setBp] = useState(796);
  const [coupons, setCoupons] = useState(865);
  const [notification, setNotification] = useState(null);
  const [capsuleAnimation, setCapsuleAnimation] = useState(false);
  const [droppingCapsules, setDroppingCapsules] = useState([]);
  const [showBuyModal, setShowBuyModal] = useState(false);
  const [buyQuantity, setBuyQuantity] = useState(1);
  const [useBPForBuy, setUseBPForBuy] = useState(false);
  const [showOpenModal, setShowOpenModal] = useState(false);
  const [currentOpeningCapsule, setCurrentOpeningCapsule] = useState(null);
  const [openedResults, setOpenedResults] = useState([]);
  const [chatInput, setChatInput] = useState('');
  const [capsuleFilter, setCapsuleFilter] = useState('NEW');
  const [chatMessages, setChatMessages] = useState([
    { user: 'Trueshot19', clanLogo: '/Clans/Clan_Logo.png', message: 'I want it :D' },
    { user: 'Trueshot19', clanLogo: '/Clans/Clan_Logo.png', message: "That's what I am aiming for :/" },
    { user: 'Bromad24', clanLogo: '/Clans/Clan_Logo.png', message: "it's so good" },
    { user: 'ValuriaE', clanLogo: '/Clans/Clan_Logo.png', message: 'I want a good side arm lol' },
    { user: 'Ddubz', clanLogo: '/Clans/Clan_Logo.png', message: 'i have enough to buy 3 capslol' },
    { user: 'Bromad24', clanLogo: '/Clans/Clan_Logo.png', message: 'with the silencer' },
    { user: 'Bromad24', clanLogo: '/Clans/Clan_Logo.png', message: 'i love it' }
  ]);
  
  const capsuleListRef = useRef(null);
  const playerChatRef = useRef(null);
  const playerListRef = useRef(null);
  
  const buyingSoundRef = useRef(null);
  const openingSoundRef = useRef(null);
  const winningSoundRef = useRef(null);
  const resetSoundRef = useRef(null);
  const buttonClickRef = useRef(null);

  const ranks = [
    { value: 1, name: 'Trainee', level: 'Trainee', image: '/Ranks/Rank1.png' },
    { value: 2, name: 'Private', level: 'Private 1st Class', image: '/Ranks/Rank 2.png' },
    { value: 3, name: 'Corporal', level: 'Corporal 2nd Class', image: '/Ranks/Rank3.png' },
    { value: 4, name: 'Sergeant', level: 'Staff Sergeant 3rd Class', image: '/Ranks/Rank4.png' },
    { value: 5, name: 'Major', level: 'Major 4th Class', image: '/Ranks/Rank5.png' }
  ];

  const initialCapsules = [
    { id: 1, name: 'Euro Jackpot (100 AP)', type: 'AP', current: 100, max: 100, cost: 100, costType: 'AP', icon: '💰', rarity: 'jackpot', description: 'Try your luck! Win thousands of Euros instantly!' },
    { id: 2, name: 'Euro Jackpot (200 AP)', type: 'AP', current: 200, max: 200, cost: 200, costType: 'AP', icon: '💰', rarity: 'jackpot', description: 'Try your luck! Win thousands of Euros instantly!' },
    { id: 3, name: 'M4A1 Custom (150 AP)', type: 'AP', current: 150, max: 150, cost: 150, costType: 'AP', icon: '🔫', rarity: 'rare', description: 'Premium M4A1 Custom rifle! Try your luck with AP!' },
    { id: 4, name: 'AK47CQB Aka', type: 'Euro', current: 282, max: 300, cost: 3000, costType: 'Euro', bpCost: 50, icon: '🔫', rarity: 'rare', description: 'The beautiful and powerful AK47CQB Aka! Claim the jackpot hidden in one of the 300 capsules!' },
    { id: 5, name: 'AK47CQB Aka (Individual)', type: 'Euro', current: 138, max: 149, cost: 3000, costType: 'Euro', bpCost: 50, icon: '🔫', rarity: 'rare', individual: true, description: 'The beautiful and powerful AK47CQB Aka! Try your luck with this individual capsule!' },
    { id: 6, name: 'Super Redhawk', type: 'Euro', current: 152, max: 200, cost: 1500, costType: 'Euro', bpCost: 25, icon: '🔫', rarity: 'epic', weapon: true, description: 'The beautiful and powerful Super Redhawk! Claim the jackpot hidden in one of the 200 capsules!' },
    { id: 7, name: 'Super Redhawk (Individual)', type: 'Euro', current: 149, max: 149, cost: 1500, costType: 'Euro', bpCost: 25, icon: '🔫', rarity: 'epic', individual: true, description: 'The beautiful and powerful Super Redhawk! Try your luck with this individual capsule!' },
    { id: 8, name: "Dual Uzi", type: 'Euro', current: 194, max: 200, cost: 2000, costType: 'Euro', bpCost: 35, icon: '🔫', rarity: 'rare', description: 'Feel the powerful firepower with your 2 barrels! Claim the jackpot hidden in one of the 200 capsules!' },
    { id: 9, name: "Dual Uzi (Individual)", type: 'Euro', current: 149, max: 149, cost: 2000, costType: 'Euro', bpCost: 35, icon: '🔫', rarity: 'rare', individual: true, description: 'Feel the powerful firepower with your 2 barrels! Try your luck with this individual capsule!' },
    { id: 10, name: 'HK416 Mjollnir', type: 'Euro', current: 166, max: 200, cost: 2500, costType: 'Euro', bpCost: 40, icon: '🔫', rarity: 'rare', description: 'Unleash the power of Mjollnir! Claim the jackpot hidden in one of the 200 capsules!' },
    { id: 11, name: 'HK416 Mjollnir (Individual)', type: 'Euro', current: 149, max: 149, cost: 2500, costType: 'Euro', bpCost: 40, icon: '🔫', rarity: 'rare', individual: true, description: 'Unleash the power of Mjollnir! Try your luck with this individual capsule!' },
    { id: 12, name: 'TAR-21 Tiamat', type: 'Euro', current: 152, max: 200, cost: 2800, costType: 'Euro', bpCost: 45, icon: '🔫', rarity: 'rare', description: 'The legendary Tiamat awaits! Claim the jackpot hidden in one of the 200 capsules!' },
    { id: 13, name: 'TAR-21 Tiamat (Individual)', type: 'Euro', current: 149, max: 149, cost: 2800, costType: 'Euro', bpCost: 45, icon: '🔫', rarity: 'rare', individual: true, description: 'The legendary Tiamat awaits! Try your luck with this individual capsule!' },
    { id: 14, name: 'S&W M29', type: 'Euro', current: 165, max: 249, cost: 1200, costType: 'Euro', bpCost: 20, icon: '🔫', rarity: 'common', description: 'Classic power and precision! Claim the jackpot hidden in one of the 249 capsules!' },
    { id: 15, name: 'Desert Eagle Gold (180 AP)', type: 'AP', current: 180, max: 180, cost: 180, costType: 'AP', icon: '🔫', rarity: 'epic', description: 'Golden Desert Eagle! Premium weapon available for AP!' },
    { id: 16, name: 'MP7A1 (120 AP)', type: 'AP', current: 120, max: 120, cost: 120, costType: 'AP', icon: '🔫', rarity: 'rare', description: 'Compact and deadly MP7A1! Get it with AP!' }
  ];

  const [capsules, setCapsules] = useState(initialCapsules);

  useEffect(() => {
    if (selectedCapsule === null && capsules.length > 0) {
      setSelectedCapsule(capsules[5]);
    }
  }, []);

  useEffect(() => {
    if (selectedCapsule) {
      const updated = capsules.find(c => c.id === selectedCapsule.id);
      if (updated) {
        setSelectedCapsule(updated);
      }
    }
  }, [capsules]);

  const playSound = (soundRef) => {
    if (soundRef.current) {
      soundRef.current.currentTime = 0;
      soundRef.current.play().catch(err => console.log('Sound play failed:', err));
    }
  };

  const handleSetupSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const rankValue = parseInt(formData.get('rank'));
    const selectedRank = ranks.find(r => r.value === rankValue);
    
    setPlayerInfo({
      playerName: formData.get('playerName'),
      clanName: formData.get('clanName'),
      rank: rankValue,
      level: selectedRank.level,
      sd: formData.get('sd'),
      expPoints: Math.min(100, parseInt(formData.get('expPoints'))),
      supplyPoints: Math.min(100, parseInt(formData.get('supplyPoints'))),
      wins: parseInt(formData.get('wins')) || 0,
      losses: parseInt(formData.get('losses')) || 0
    });
    setShowSetup(false);
  };

  const getCapsuleNameColor = (capsule) => {
    if (capsule.rarity === 'jackpot') return '#ebebeb';
    if (capsule.costType === 'Euro') return '#00ade8';
    if (capsule.costType === 'AP') return '#ff6c1a';
    return '#ffffff';
  };

  const addDroppingCapsules = (quantity) => {
    const colors = ['bg-red-500', 'bg-blue-500', 'bg-green-500', 'bg-yellow-400', 'bg-purple-500'];
    const newCapsules = [];
    
    for (let i = 0; i < quantity; i++) {
      newCapsules.push({
        id: Date.now() + i,
        color: colors[Math.floor(Math.random() * colors.length)],
        delay: i * 150,
        left: 40 + Math.random() * 20
      });
    }
    setDroppingCapsules(prev => [...prev, ...newCapsules]);
    setTimeout(() => {
      setDroppingCapsules(prev => prev.filter(c => !newCapsules.find(nc => nc.id === c.id)));
    }, 2000 + (quantity * 150));
  };

  const openBuyModal = (quantity) => {
    if (!selectedCapsule || unopenedCapsules.length >= 50) {
      alert('Cannot buy more capsules! Maximum 50 unopened capsules.');
      return;
    }
    playSound(buttonClickRef);
    setBuyQuantity(quantity);
    setUseBPForBuy(false);
    setShowBuyModal(true);
  };

  const confirmBuy = () => {
    const actualQuantity = Math.min(buyQuantity, 50 - unopenedCapsules.length);
    let totalCost = 0;
    let costType = selectedCapsule.costType;

    if (useBPForBuy && selectedCapsule.bpCost) {
      const bpNeeded = selectedCapsule.bpCost * actualQuantity;
      if (bp < bpNeeded) {
        alert('Not enough Battle Points!');
        setShowBuyModal(false);
        return;
      }
      totalCost = (selectedCapsule.cost / 3) * actualQuantity;
      if (costType === 'Euro' && euros < totalCost) {
        alert('Not enough Euros!');
        setShowBuyModal(false);
        return;
      }
      setBp(bp - bpNeeded);
    } else {
      totalCost = selectedCapsule.cost * actualQuantity;
    }

    if (costType === 'Euro' && euros < totalCost) {
      alert('Not enough Euros!');
      setShowBuyModal(false);
      return;
    } else if (costType === 'AP' && ap < totalCost) {
      alert('Not enough AP!');
      setShowBuyModal(false);
      return;
    }

    playSound(buyingSoundRef);
    if (costType === 'Euro') {
      setEuros(euros - totalCost);
    } else {
      setAp(ap - totalCost);
      setCoupons(coupons + (actualQuantity * 5));
    }

    addDroppingCapsules(actualQuantity);
    const newUnopenedCapsules = [];
    let wonCapsule = false;

    const newCapsules = capsules.map(c => {
      if (c.id === selectedCapsule.id) {
        let newCurrent = c.current;
        
        for (let i = 0; i < actualQuantity; i++) {
          newCurrent = Math.max(0, newCurrent - 1);
          
          const winChance = 1 / newCurrent;
          const isWinner = Math.random() < winChance || newCurrent === 0;
          
          newUnopenedCapsules.push({
            id: Date.now() + i,
            capsuleId: c.id,
            capsuleName: c.name,
            capsuleIcon: c.icon,
            capsuleCostType: c.costType,
            isWinner: isWinner && !c.individual
          });

          if (isWinner && !c.individual && !wonCapsule) {
            wonCapsule = true;
            setTimeout(() => {
              playSound(resetSoundRef);
            }, 500);
            newCurrent = c.max;
          }
        }
        return { ...c, current: newCurrent };
      }
      return c;
    });

    setUnopenedCapsules(prev => [...prev, ...newUnopenedCapsules]);
    setCapsules(newCapsules);
    setCapsuleAnimation(true);
    setTimeout(() => setCapsuleAnimation(false), 500);
    setShowBuyModal(false);
  };

  const openSingleCapsule = () => {
    if (unopenedCapsules.length === 0) return;
    
    const capsuleToOpen = unopenedCapsules[0];
    
    if (capsuleToOpen.isWinner) {
      capsuleToOpen.reward = { type: 'weapon', name: capsuleToOpen.capsuleName };
    } else {
      const rewardType = Math.random();
      if (capsuleToOpen.capsuleCostType === 'AP') {
        if (rewardType < 0.3) {
          const apReward = Math.floor(Math.random() * 50) + 10;
          capsuleToOpen.reward = { type: 'ap', amount: apReward };
        } else {
          const euroReward = Math.floor(Math.random() * 5000) + 1000;
          capsuleToOpen.reward = { type: 'euro', amount: euroReward };
        }
      } else {
        const euroReward = Math.floor(Math.random() * 5000) + 1000;
        capsuleToOpen.reward = { type: 'euro', amount: euroReward };
      }
    }
    
    setCurrentOpeningCapsule(capsuleToOpen);
    setShowOpenModal(true);
    
    if (capsuleToOpen.isWinner) {
      playSound(winningSoundRef);
    } else {
      playSound(openingSoundRef);
    }
  };

  const closeOpenModal = () => {
    if (currentOpeningCapsule && !currentOpeningCapsule.isWinner) {
      if (currentOpeningCapsule.reward.type === 'euro') {
        setEuros(euros + currentOpeningCapsule.reward.amount);
      } else if (currentOpeningCapsule.reward.type === 'ap') {
        setAp(ap + currentOpeningCapsule.reward.amount);
      }
    }
    
    setUnopenedCapsules(prev => prev.slice(1));
    setShowOpenModal(false);
    setCurrentOpeningCapsule(null);
  };

  const openAllCapsules = () => {
    if (unopenedCapsules.length === 0) return;
    
    const results = [];
    let totalEuroRewards = 0;
    let totalAPRewards = 0;
    
    unopenedCapsules.forEach(capsule => {
      if (capsule.isWinner) {
        results.push({
          type: 'weapon',
          name: capsule.capsuleName,
          icon: capsule.capsuleIcon,
          isWinner: true
        });
      } else {
        const rewardType = Math.random();
        if (capsule.capsuleCostType === 'AP') {
          if (rewardType < 0.3) {
            const apReward = Math.floor(Math.random() * 50) + 10;
            totalAPRewards += apReward;
            results.push({
              type: 'ap',
              amount: apReward,
              isWinner: false
            });
          } else {
            const euroReward = Math.floor(Math.random() * 5000) + 1000;
            totalEuroRewards += euroReward;
            results.push({
              type: 'euro',
              amount: euroReward,
              isWinner: false
            });
          }
        } else {
          const euroReward = Math.floor(Math.random() * 5000) + 1000;
          totalEuroRewards += euroReward;
          results.push({
            type: 'euro',
            amount: euroReward,
            isWinner: false
          });
        }
      }
    });
    
    const hasWinners = results.some(r => r.isWinner);
    
    if (hasWinners) {
      playSound(winningSoundRef);
    } else {
      playSound(openingSoundRef);
    }
    
    setEuros(euros + totalEuroRewards);
    setAp(ap + totalAPRewards);
    setOpenedResults(results);
    setShowOpenModal(true);
    setUnopenedCapsules([]);
  };

  const closeOpenAllModal = () => {
    setShowOpenModal(false);
    setOpenedResults([]);
  };

  const handleChatSubmit = (e) => {
    e.preventDefault();
    if (chatInput.trim() && playerInfo) {
      setChatMessages(prev => [...prev, { 
        user: playerInfo.playerName, 
        clanLogo: '/Clans/Clan_Logo.png',  // Use playerInfo.clanLogo if you add it to playerInfo
        message: chatInput 
      }]);
      setChatInput('');
      setTimeout(() => {
        if (playerChatRef.current) {
          playerChatRef.current.scrollTop = playerChatRef.current.scrollHeight;
        }
      }, 0);
    }
  };

  if (showSetup) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black text-gray-100 flex items-center justify-center p-4" style={{ fontFamily: 'AVAFont, sans-serif' }}>
        <div className="bg-gray-800 rounded-lg p-8 max-w-2xl w-full border-2 border-yellow-600">
          <h1 className="text-3xl font-bold text-yellow-500 mb-6 text-center">Player Setup</h1>
          <form onSubmit={handleSetupSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-bold mb-2">Player Name:</label>
              <input type="text" name="playerName" defaultValue="Player1" required className="w-full bg-gray-700 text-white px-4 py-2 rounded" />
            </div>
            <div>
              <label className="block text-sm font-bold mb-2">Clan Name:</label>
              <input type="text" name="clanName" defaultValue="MyClan" required className="w-full bg-gray-700 text-white px-4 py-2 rounded" />
            </div>
            <div>
              <label className="block text-sm font-bold mb-2">Rank:</label>
              <select name="rank" defaultValue="4" required className="w-full bg-gray-700 text-white px-4 py-2 rounded">
                {ranks.map(rank => (
                  <option key={rank.value} value={rank.value}>{rank.name} - {rank.level}</option>
                ))}
              </select>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-bold mb-2">Wins:</label>
                <input type="number" name="wins" defaultValue="150" required className="w-full bg-gray-700 text-white px-4 py-2 rounded" />
              </div>
              <div>
                <label className="block text-sm font-bold mb-2">Losses:</label>
                <input type="number" name="losses" defaultValue="75" required className="w-full bg-gray-700 text-white px-4 py-2 rounded" />
              </div>
            </div>
            <div>
              <label className="block text-sm font-bold mb-2">S/D Ratio:</label>
              <input type="text" name="sd" defaultValue="1.812" required className="w-full bg-gray-700 text-white px-4 py-2 rounded" placeholder="e.g., 1.812" />
            </div>
            <div>
              <label className="block text-sm font-bold mb-2">Experience Points (%):</label>
              <input type="number" name="expPoints" min="0" max="100" defaultValue="75" required className="w-full bg-gray-700 text-white px-4 py-2 rounded" />
            </div>
            <div>
              <label className="block text-sm font-bold mb-2">Supply Points (%):</label>
              <input type="number" name="supplyPoints" min="0" max="100" defaultValue="60" required className="w-full bg-gray-700 text-white px-4 py-2 rounded" />
            </div>
            <button type="submit" className="w-full bg-yellow-600 hover:bg-yellow-700 text-white font-bold py-3 px-6 rounded transition-colors">
              Enter Capsule Shop
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="relative w-full h-screen overflow-hidden bg-black flex items-center justify-center" style={{ fontFamily: 'AVAFont, sans-serif' }}>
      <audio ref={buyingSoundRef} src="/Buying_Capsule.mp3" />
      <audio ref={openingSoundRef} src="/Opening_Capsule.mp3" />
      <audio ref={winningSoundRef} src="/Winning_Capsule.mp3" />
      <audio ref={resetSoundRef} src="/Capsule_Reset.mp3" />
      <audio ref={buttonClickRef} src="/Button_Click.mp3" />

      <div className="relative" style={{ width: '1784px', height: '1001px' }}>
        {/* Capsule List */}
        <div className="absolute" style={{ left: '0px', top: '111px', width: '440px', height: '603px' }}>
          <img 
            src={
              capsuleFilter === 'Euro' ? '/BG/Capsule_List_Euro_BG.png' :
              capsuleFilter === 'AP' ? '/BG/Capsule_List_AP_BG.png' :
              '/BG/Capsule_List_BG.png'
            } 
            alt="Capsule List Background" 
            className="absolute top-0 left-0 w-full h-full" 
          />
          
          {/* NEW Button */}
          <button 
            onClick={() => {
              playSound(buttonClickRef);
              setCapsuleFilter('NEW');
            }}
            className="absolute"
            style={{ left: '16px', top: '64px', width: '84px', height: '23px' }}
          />

          {/* Euro Button */}
          <button 
            onClick={() => {
              playSound(buttonClickRef);
              setCapsuleFilter('Euro');
            }}
            className="absolute"
            style={{ left: '147px', top: '60px', width: '84px', height: '24px' }}
          />

          {/* AP Button */}
          <button 
            onClick={() => {
              playSound(buttonClickRef);
              setCapsuleFilter('AP');
            }}
            className="absolute"
            style={{ left: '271px', top: '61px', width: '98px', height: '29px' }}
          />
          <div 
            ref={capsuleListRef}
            className="absolute overflow-y-scroll custom-scrollbar" 
            style={{ 
              left: '14px',        // Keep content starting position
              top: '98px',         // Content starts here
              width: '428px',      // Extend width to 390 + (414-390) + space = accommodates scrollbar at 390-414
              height: '467px',     // Height to make scrollbar span 116-530 (414px total)
              paddingTop: '0px',  // Offset so content aligns properly (116-98=18)
              paddingRight: '26px' // Push content away from scrollbar area (space from content end to scrollbar start)
            }}
          >
            {capsules.filter(capsule => {
              if (capsuleFilter === 'NEW') return true;
              if (capsuleFilter === 'Euro') return capsule.costType === 'Euro';
              if (capsuleFilter === 'AP') return capsule.costType === 'AP';
              return true;
            }).map(capsule => (
              <div
                key={capsule.id}
                onClick={() => {
                  playSound(buttonClickRef);
                  setSelectedCapsule(capsule);
                }}
                className="relative cursor-pointer mb-1"
                style={{ height: '32px' }}
              >
                <img 
                  src={selectedCapsule?.id === capsule.id ? '/BG/Capsule_List_List_Clicked_BG.png' : '/BG/Capsule_List_List_BG.png'} 
                  alt="List Item" 
                  className="absolute top-0 left-0 w-full h-full" 
                />
                <div className="absolute inset-0 flex items-center justify-between px-3">
                  <span className="truncate flex-1" style={{ color: getCapsuleNameColor(capsule), fontSize: '17.5px' }}>
                    {capsule.name}
                  </span>
                  {!capsule.individual && (
                    <span className="font-bold ml-2" style={{ color: selectedCapsule?.id === capsule.id ? '#b19050' : '#bbbbbb', fontSize: '17.5px' }}>
                      {capsule.current}/{capsule.max}
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Capsule Machine Center */}
        <div className="absolute" style={{ left: '550px', top: '200px', width: '400px', height: '400px' }}>
          <img 
            src="https://static.wikia.nocookie.net/ava/images/8/85/Capsule_Shop.gif" 
            alt="Capsule Machine" 
            className="w-full h-full object-contain"
          />
        </div>

        {/* Capsule Count */}
        {selectedCapsule && !selectedCapsule.individual && (
          <div className="absolute" style={{ left: '1009px', top: '614px', width: '251px', height: '101px' }}>
            <img src="/BG/Capsule_Count_BG.png" alt="Count Background" className="absolute top-0 left-0 w-full h-full" />
            <div className="absolute flex items-center justify-center" style={{ left: '102px', top: '33px', width: '127px', height: '41px', fontFamily: 'AVAFont_Num, monospace', fontSize: '55px', color: '#92e000' }}>
              {selectedCapsule?.current || '0'}
            </div>
          </div>
        )}

        {/* Capsule Info */}
        <div className="absolute" style={{ left: '1262px', top: '113px', width: '522px', height: '600px' }}>
          <img src="/BG/Capsule_Info_BG.png" alt="Info Background" className="absolute top-0 left-0 w-full h-full" />
          
          {selectedCapsule && (
            <>
              <div className="absolute flex items-center justify-center text-center" style={{ left: '74px', top: '409px', width: '60px', height: '26px', fontSize: '30px', color: '#e9ae02', fontFamily: 'AVAFont_Num, monospace' }}>
                {unopenedCapsules.length || '0'}
              </div>
              <div className="absolute text-center" style={{ left: '119px', top: '15px', width: '281px', height: '23px', fontSize: '17.5px', color: getCapsuleNameColor(selectedCapsule), lineHeight: '23px' }}>
                {selectedCapsule.name}
              </div>
              <div className="absolute flex items-center justify-center text-6xl" style={{ left: '128px', top: '59px', width: '288px', height: '78px' }}>
                {selectedCapsule.icon}
              </div>
              <div className="absolute text-center" style={{ left: '29px', top: '155px', width: '460px', height: '63px', color: '#f6d98b', fontSize: '14.9px', lineHeight: '1.4' }}>
                {selectedCapsule.description}
              </div>
              <div className="absolute flex items-center gap-1" style={{ left: '141px', top: '251px', width: '250px', height: '23px', fontSize: '17.5px', color: '#b9b9b9' }}>
                <span>Price : </span>
                <img src={selectedCapsule.costType === 'Euro' ? '/BG/Euro_Symbol.png' : '/BG/AP_Symbol.png'} alt="Currency" style={{ height: '17.5px' }} />
                <span>{selectedCapsule.cost.toLocaleString()}</span>
              </div>
              {selectedCapsule.bpCost && (
                <div className="absolute flex items-center gap-1" style={{ left: '141px', top: '277px', width: '300px', height: '24px', fontSize: '17.5px', color: '#b9b9b9' }}>
                  <span>Price : </span>
                  <img src="/BG/Euro_Symbol.png" alt="Euro" style={{ height: '17.5px' }} />
                  <span>{(selectedCapsule.cost / 3).toLocaleString()}</span>
                  <span>+</span>
                  <img src="/BG/BP_Symbol.png" alt="BP" style={{ height: '17.5px' }} />
                  <span>{selectedCapsule.bpCost}</span>
                </div>
              )}
              <button onClick={() => openBuyModal(1)} className="absolute" style={{ left: '26px', top: '360px', width: '156px', height: '39px' }} />
              <button onClick={() => openBuyModal(5)} className="absolute" style={{ left: '185px', top: '357px', width: '157px', height: '41px' }} />
              <button onClick={() => openBuyModal(10)} className="absolute" style={{ left: '347px', top: '357px', width: '156px', height: '41px' }} />
              
              <button onClick={openSingleCapsule} disabled={unopenedCapsules.length === 0} className="absolute" style={{ left: '185px', top: '401px', width: '157px', height: '39px' }} />
              
              <button onClick={openAllCapsules} disabled={unopenedCapsules.length === 0} className="absolute" style={{ left: '344px', top: '402px', width: '159px', height: '38px' }} />
            </>
          )}
        </div>

        {/* Profile/Chat/Players Bottom Section */}
        <div className="absolute" style={{ left: '0px', top: '714px', width: '1784px', height: '288px' }}>
          <img src="/BG/Profile_Chat_Players_BG.png" alt="Bottom Background" className="absolute top-0 left-0 w-full h-full" />
          
          {playerInfo && (
            <>
              <div className="absolute" style={{ left: '10px', top: '8px', width: '42px', height: '35px' }}>
                <img src={ranks.find(r => r.value === playerInfo.rank)?.image} alt="Rank" style={{ height: '28px' }} />
              </div>
              <div className="absolute" style={{ left: '45px', top: '2px', width: '211px', height: '35px', fontSize: '22px', color: '#e0e0e0', lineHeight: '35px' }}>
                {playerInfo.playerName}
              </div>
              <div className="absolute" style={{ left: '77px', top: '51px', width: '34px', height: '23px' }}>
                <img src="/Clans/Clan_Logo.png" alt="Clan" style={{ height: '24px' }} />
              </div>
              <div className="absolute" style={{ left: '107px', top: '50px', width: '114px', height: '18px', fontSize: '17.5px', color: '#b9b9b9' }}>
                {playerInfo.clanName}
              </div>
              <div className="absolute" style={{ left: '88px', top: '73px', width: '295px', height: '16px', fontSize: '17.5px', color: '#b9b9b9' }}>
                {playerInfo.level}
              </div>
              <div className="absolute" style={{ left: '165px', top: '96.5px', width: '256px', height: '13px', fontSize: '17.5px', color: '#b9b9b9' }}>
                {playerInfo.wins}Wins {playerInfo.losses}Losses
              </div>
              <div className="absolute" style={{ left: '63px', top: '121.5px', width: '56px', height: '16px', fontSize: '17.5px', color: '#b9b9b9' }}>
                {playerInfo.sd}
              </div>
              <div className="absolute flex items-center gap-2" style={{ left: '229px', top: '152.5px', width: '180px', height: '17.5px', fontSize: '17.5px', color: '#b9b9b9' }}>
                <div className="w-32 bg-gray-700 h-3.5 rounded">
                  <div className="bg-orange-500 h-3.5 rounded" style={{ width: `${playerInfo.expPoints}%` }}></div>
                </div>
                <span>{playerInfo.expPoints}%</span>
              </div>
              <div className="absolute flex items-center gap-2" style={{ left: '182px', top: '177px', width: '180px', height: '17.5px', fontSize: '17.5px', color: '#b9b9b9' }}>
                <div className="w-32 bg-gray-700 h-3.5 rounded">
                  <div className="bg-orange-500 h-3.5 rounded" style={{ width: `${playerInfo.supplyPoints}%` }}></div>
                </div>
                <span>{playerInfo.supplyPoints}%</span>
              </div>
              <div className="absolute" style={{ left: '140px', top: '196px', width: '97px', height: '13px', fontSize: '17.5px', color: '#b9b9b9' }}>
                {euros.toLocaleString()}
              </div>
              <div className="absolute" style={{ left: '98px', top: '222px', width: '63px', height: '16px', fontSize: '17.5px', color: '#b9b9b9' }}>
                {ap.toLocaleString()}
              </div>
              <div className="absolute" style={{ left: '245px', top: '220.5px', width: '45px', height: '16px', fontSize: '17.5px', color: '#b9b9b9' }}>
                {bp}
              </div>
            </>
          )}

          {/* Chat History */}
          <div 
            ref={playerChatRef}
            className="absolute overflow-y-scroll custom-scrollbar" 
            style={{ 
              left: '451px', 
              top: '44px', 
              width: '809px', 
              height: '177px'
            }}
          >
            <div className="text-orange-400 text-center text-xs mb-2">
              [TIP] Press Ctrl+PageUp/PageDown to bring up previously sent messages.
            </div>
            {chatMessages.map((msg, idx) => (
              <div key={idx} style={{ fontSize: '17.5px' }} className="flex items-center gap-1">
                <img src={msg.clanLogo} alt="Clan" style={{ height: '21px' }} />
                <span style={{ color: '#cab581' }}>{msg.user}</span>
                <span style={{ color: '#acacac' }}>: {msg.message}</span>
              </div>
            ))}
          </div>
          
          {/* Chat Input */}
          <form onSubmit={handleChatSubmit} className="absolute" style={{ left: '544px', top: '224px', width: '711px', height: '20px' }}>
            <input
              type="text"
              value={chatInput}
              onChange={(e) => setChatInput(e.target.value)}
              className="w-full h-full bg-transparent text-white outline-none"
              style={{ fontSize: '17.5px', color: '#acacac' }}
              placeholder="Type your message..."
            />
          </form>

          {/* Players List */}
          <div 
            ref={playerListRef}
            className="absolute overflow-y-scroll custom-scrollbar" 
            style={{ 
              left: '1281px', 
              top: '74px', 
              width: '487px', 
              height: '163px'
            }}
          >
            <div className="space-y-2">
              {['1NicK', '2Ky', 'afletic', 'Ahillesi', 'Amelia Tam'].map((player, idx) => (
                <div key={idx} className="flex items-center gap-2">
                  <div style={{ width: '33px', height: '27px' }}>
                    <img src={ranks[idx % ranks.length]?.image} alt="Rank" style={{ height: '22px' }} />
                  </div>
                  <span style={{ color: '#b9b9b9', fontSize: '17.5px' }}>{player}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Buy Modal */}
      {showBuyModal && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
          <div className="bg-gradient-to-b from-gray-800 to-gray-900 rounded-lg p-6 max-w-3xl w-full border-2 border-yellow-600">
            <div className="text-center mb-6">
              <h2 className="text-2xl font-bold mb-2">
                <span style={{ color: '#d4af37' }}>Buy Capsule(s) of </span>
                <span style={{ color: getCapsuleNameColor(selectedCapsule) }}>{selectedCapsule?.name}</span>
                <span style={{ color: '#d4af37' }}> : {buyQuantity}</span>
              </h2>
            </div>
            <div className="flex justify-center mb-6">
              <div className="text-8xl">{selectedCapsule?.icon}</div>
            </div>
            {selectedCapsule?.bpCost && (
              <div className="mb-6 flex justify-center gap-4">
                <label className="flex items-center cursor-pointer">
                  <input
                    type="radio"
                    checked={!useBPForBuy}
                    onChange={() => setUseBPForBuy(false)}
                    className="mr-2"
                  />
                  <span style={{ color: '#d4af37' }}>
                    Price: {selectedCapsule.costType === 'Euro' ? `€${(selectedCapsule.cost * buyQuantity).toLocaleString()}` : `${(selectedCapsule.cost * buyQuantity).toLocaleString()} AP`}
                  </span>
                </label>
                <label className="flex items-center cursor-pointer">
                  <input
                    type="radio"
                    checked={useBPForBuy}
                    onChange={() => setUseBPForBuy(true)}
                    className="mr-2"
                  />
                  <span style={{ color: '#d4af37' }}>
                    Price: {selectedCapsule.costType === 'Euro' ? `€${((selectedCapsule.cost / 3) * buyQuantity).toLocaleString()}` : `${((selectedCapsule.cost / 3) * buyQuantity).toLocaleString()} AP`} + {selectedCapsule.bpCost * buyQuantity} BP
                  </span>
                </label>
              </div>
            )}
            {!selectedCapsule?.bpCost && (
              <div className="mb-6 text-center" style={{ color: '#d4af37' }}>
                Price: {selectedCapsule?.costType === 'Euro' ? `€${(selectedCapsule.cost * buyQuantity).toLocaleString()}` : `${(selectedCapsule.cost * buyQuantity).toLocaleString()} AP`}
              </div>
            )}
            <div className="bg-gray-700 rounded p-4 mb-6">
              <p className="text-sm text-gray-300 mb-4">
                {selectedCapsule?.description}
              </p>
              <div className="text-xs" style={{ color: '#d4af37' }}>
                <p className="mb-2">[Possible prizes]</p>
                <p className="text-gray-300 mb-4">
                  {selectedCapsule?.name} (Permanent), Various temporary items...
                </p>
                <p className="text-gray-400">
                  *Items that appear in the purchase window are still available for others to buy.<br/>
                  *A player can have no more than 50 capsules total.<br/>
                  *Staff Sergeant 3 Requirement to purchase<br/>
                  *Can't purchase when user has under 20,000 Euros or if user will have under 20,000 Euros after the purchase.
                </p>
              </div>
            </div>
            <div className="flex justify-between text-sm mb-6">
              <div>Current money: <span style={{ color: '#d4af37' }}>
                €{euros.toLocaleString()} (+{Math.floor(euros * 0.05).toLocaleString()})
              </span></div>
              <div>Money after buying: <span style={{ color: '#d4af37' }}>
                {selectedCapsule?.costType === 'Euro' 
                  ? `€${(euros - (useBPForBuy && selectedCapsule?.bpCost ? (selectedCapsule.cost / 3) * buyQuantity : selectedCapsule.cost * buyQuantity)).toLocaleString()}`
                  : `€${euros.toLocaleString()}`
                } (+{Math.floor((euros - (selectedCapsule?.costType === 'Euro' ? (useBPForBuy && selectedCapsule?.bpCost ? (selectedCapsule.cost / 3) * buyQuantity : selectedCapsule.cost * buyQuantity) : 0)) * 0.05).toLocaleString()})
              </span></div>
            </div>
            <div className="text-center mb-6" style={{ color: '#d4af37' }}>
              Remaining capsules: {selectedCapsule?.individual ? '???' : selectedCapsule?.current}
            </div>
            <div className="flex gap-4">
              <button
                onClick={confirmBuy}
                className="flex-1 bg-gray-600 hover:bg-gray-500 text-white font-bold py-3 px-6 rounded transition-colors"
              >
                Buy
              </button>
              <button
                onClick={() => {
                  playSound(buttonClickRef);
                  setShowBuyModal(false);
                }}
                className="flex-1 bg-gray-600 hover:bg-gray-500 text-white font-bold py-3 px-6 rounded transition-colors"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Open Modal */}
      {showOpenModal && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
          <div className="bg-gradient-to-b from-gray-800 to-gray-900 rounded-lg p-6 max-w-4xl w-full border-2 border-yellow-600 max-h-[90vh] flex flex-col">
            <div className="text-center mb-6">
              <h2 className="text-2xl font-bold text-white">
                {openedResults.length > 0 ? 'Open' : currentOpeningCapsule?.isWinner ? 'Open Capsule' : 'Open'}
              </h2>
            </div>
            {currentOpeningCapsule && openedResults.length === 0 && (
              <>
                {currentOpeningCapsule.isWinner ? (
                  <>
                    <div className="flex items-center mb-6 bg-yellow-900 bg-opacity-30 border-2 border-yellow-500 rounded p-4">
                      <div className="mr-4">
                        <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='120'%3E%3Ctext x='50%25' y='50%25' text-anchor='middle' dy='.3em' font-size='80'%3E⭐%3C/text%3E%3C/svg%3E" alt="Lucky" className="w-24 h-24" />
                        <div className="text-yellow-400 font-bold text-center text-sm">LUCKY<br/>CAPSULE</div>
                      </div>
                      <div className="flex-1">
                        <div className="text-yellow-400 font-bold mb-2 text-xl">Congratulations! You have won a jackpot capsule.</div>
                        <div className="flex items-start">
                          <div className="text-8xl mr-4">{currentOpeningCapsule.capsuleIcon}</div>
                          <div>
                            <div className="text-white font-bold mb-1 text-lg">{currentOpeningCapsule.capsuleName}</div>
                            <div className="text-gray-300 text-sm">
                              A premium weapon from the capsule collection.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="text-center mb-4 text-yellow-400">Current capsules: {unopenedCapsules.length - 1}</div>
                  </>
                ) : (
                  <>
                    <div className="flex items-center mb-6 bg-gray-700 bg-opacity-50 border-2 border-gray-500 rounded p-4">
                      <div className="flex items-start flex-1">
                        <div className="text-6xl mr-4">{currentOpeningCapsule.reward.type === 'ap' ? '🎯' : '💶'}</div>
                        <div>
                          <div className="text-yellow-400 font-bold mb-1">Consolation Prize</div>
                          <div className="text-gray-300 text-sm">
                            You received {currentOpeningCapsule.reward.type === 'ap' 
                              ? `${currentOpeningCapsule.reward.amount} AP` 
                              : `${currentOpeningCapsule.reward.amount} Euros`}. Better luck next time!
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="text-center mb-4 text-yellow-400">Count: {unopenedCapsules.length - 1}</div>
                  </>
                )}
                <div className="flex gap-4">
                  {unopenedCapsules.length > 1 && (
                    <button
                      onClick={() => {
                        closeOpenModal();
                        setTimeout(() => openSingleCapsule(), 100);
                      }}
                      className="flex-1 bg-gray-600 hover:bg-gray-500 text-white font-bold py-3 px-6 rounded transition-colors"
                    >
                      Open more
                    </button>
                  )}
                  <button
                    onClick={() => {
                      playSound(buttonClickRef);
                      closeOpenModal();
                    }}
                    className="flex-1 bg-gray-600 hover:bg-gray-500 text-white font-bold py-3 px-6 rounded transition-colors"
                  >
                    Ok
                  </button>
                </div>
              </>
            )}
            {openedResults.length > 0 && (
              <>
                <div className="flex-1 overflow-y-auto mb-6 space-y-3">
                  {openedResults.map((result, index) => (
                    <div key={index} className={`flex items-center p-4 rounded border-2 ${
                      result.isWinner 
                        ? 'bg-yellow-900 bg-opacity-30 border-yellow-500' 
                        : 'bg-gray-700 bg-opacity-50 border-gray-500'
                    }`}>
                      {result.isWinner ? (
                        <>
                          <div className="mr-4">
                            <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80'%3E%3Ctext x='50%25' y='50%25' text-anchor='middle' dy='.3em' font-size='60'%3E⭐%3C/text%3E%3C/svg%3E" alt="Lucky" className="w-16 h-16" />
                          </div>
                          <div className="flex-1">
                            <div className="text-yellow-400 font-bold mb-1">🎉 Jackpot Winner!</div>
                            <div className="flex items-center">
                              <div className="text-5xl mr-3">{result.icon}</div>
                              <div className="text-white font-bold">{result.name}</div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="text-5xl mr-4">{result.type === 'ap' ? '🎯' : '💶'}</div>
                          <div className="flex-1">
                            <div className="text-yellow-400 font-bold mb-1">Consolation Prize</div>
                            <div className="text-gray-300">
                              {result.type === 'ap' ? `${result.amount} AP` : `${result.amount} Euros`}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  ))}
                </div>
                <div className="text-center mb-4 text-yellow-400">
                  Opened {openedResults.length} capsules
                </div>
                <button
                  onClick={() => {
                    playSound(buttonClickRef);
                    closeOpenAllModal();
                  }}
                  className="w-full bg-gray-600 hover:bg-gray-500 text-white font-bold py-3 px-6 rounded transition-colors"
                >
                  Ok
                </button>
              </>
            )}
          </div>
        </div>
      )}

      <style jsx>{`
        @font-face {
          font-family: 'AVAFont';
          src: url('/AVAFont.ttf') format('truetype');
        }
        
        @font-face {
          font-family: 'AVAFont_Num';
          src: url('/AVAFont_Num.ttf') format('truetype');
        }
        
        .custom-scrollbar::-webkit-scrollbar {
          width: 25px !important;
          height: 25px !important;
        }

        .custom-scrollbar::-webkit-scrollbar-track {
          background: rgba(0, 0, 0, 0.1);
          width: 25px !important;
        }

        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #3c3d38 !important;
          border: none !important;
          border-radius: 0 !important;
          width: 25px !important;
          min-height: 50px;
        }

        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #4a4b45 !important;
        }
        
        @keyframes drop {
          0% {
            top: -40px;
            opacity: 1;
          }
          70% {
            opacity: 1;
          }
          100% {
            top: calc(100% + 20px);
            opacity: 0;
          }
        }
        .animate-drop {
          animation-name: drop;
          animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);
        }
      `}</style>
    </div>
  );
};

export default CapsuleShop;